import { Flex, Text } from '@servicetitan/anvil2';
import { HtmlContent } from '@servicetitan/financing-utils-shared';
import { EqualOpportunityLender } from '@servicetitan/financing-provider-assets';
import * as styles from './GreenSkyPreApprovalDisclosure.module.scss';

interface GreenSkyPreApprovalDisclosureProps {
    /** GreenSky's `General` prescreen disclosure body; may contain provider HTML markup. */
    text: string;
    className?: string;
}

/**
 * GreenSky's FCRA prescreen notice, rendered as fine print beneath the pre-approval banner.
 * The logo and the "PRESCREEN & OPT-OUT NOTICE:" label are static UI; only the body comes from
 * the API and is sanitized via {@link HtmlContent}.
 */
export const GreenSkyPreApprovalDisclosure = ({
    text,
    className,
}: GreenSkyPreApprovalDisclosureProps) => {
    if (!text) {
        // Defensive: the banner is already suppressed when the General disclosure is absent.
        return null;
    }

    return (
        <Flex gap="3" alignItems="flex-start" className={className}>
            <img
                src={EqualOpportunityLender}
                alt="Equal Opportunity Lender"
                className={styles.logo}
            />
            <Flex direction="column" gap="1">
                <Text variant="body" size="small" subdued>
                    <strong>PRESCREEN &amp; OPT-OUT NOTICE:</strong>
                </Text>
                {/* HtmlContent renders a block <div>, so it is a sibling of the inline label
                    rather than nested inside it (avoids invalid DOM nesting). */}
                <div className={styles.disclosureBody}>
                    <HtmlContent content={text} />
                </div>
            </Flex>
        </Flex>
    );
};
